'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import { TruncateWithShowButton } from '@libs/common-next';
import { Observer } from '@libs/contentful/utils';
import { storeAboutSeoTrackingData, trackStoreAboutSeoExpand } from './store-about-seo-analytics';
interface StoreAboutSeoBlockContentProps {
  children: ReactNode;
}
export function StoreAboutSeoBlockContent(t0) {
  const $ = _c(4);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Observer {...storeAboutSeoTrackingData} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      showMore: "Read more",
      showLess: "Read less"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <>{t1}<TruncateWithShowButton truncateLine={2} buttonWordings={t2} className="seo-block__button" handleClick={trackStoreAboutSeoExpand}>{children}</TruncateWithShowButton></>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}